const urgencyLevels = {
  high: { label: '緊急度:高', color: 'danger', icon: '🔴', order: 0 },
  medium: { label: '緊急度:中', color: 'warning', icon: '🟡', order: 1 },
  low: { label: '緊急度:低', color: 'info', icon: '🔵', order: 2 },
  done: { label: '対応済み', color: 'success', icon: '🟢', order: 3 },
};

const detectUrgency = (tag) => {
  if (/対応済み/.test(tag)) return 'done';
  if (/緊急度\s*[:：]\s*高/.test(tag)) return 'high';
  if (/緊急度\s*[:：]\s*中/.test(tag)) return 'medium';
  if (/緊急度\s*[:：]\s*低/.test(tag)) return 'low';
  return null;
};

const parseItem = (block) => {
  const lines = block.split('\n').map(_ => _.trim()).filter(Boolean);
  if (lines.length === 0) return null;
  const header = lines[0];
  const m = header.match(/^■\s*(.+?)\s*\[(.+?)\]\s*$/);
  if (!m) return null;
  const name = m[1];
  const tag = m[2];
  const urgency = detectUrgency(tag);
  if (!urgency) return null;

  const rest = lines.slice(1);
  const situationLine = rest.find(_ => /^状況\s*[:：]/.test(_));
  const actionLine = rest.find(_ => /^対応\s*[:：]/.test(_));
  const situation = situationLine ? situationLine.replace(/^状況\s*[:：]\s*/, '') : null;
  const action = actionLine ? actionLine.replace(/^対応\s*[:：]\s*/, '') : null;
  const note = (!situation && !action) ? rest.join('\n') : null;

  return { name, urgency, situation, action, note };
};

const parseAdvice = (body) => {
  if (!body || typeof body !== 'string') return { items: [], preface: '' };
  const trimmed = body.trim();
  const firstMarker = trimmed.indexOf('■');
  if (firstMarker < 0) return { items: [], preface: trimmed };
  const preface = trimmed.slice(0, firstMarker).trim();
  const rest = trimmed.slice(firstMarker);
  const blocks = rest.split(/\n(?=■)/).map(_ => _.trim()).filter(Boolean);
  const items = blocks.map(parseItem).filter(Boolean);
  return { items, preface };
};

const countByUrgency = (items) => ({
  high: items.filter(_ => _.urgency === 'high').length,
  medium: items.filter(_ => _.urgency === 'medium').length,
  low: items.filter(_ => _.urgency === 'low').length,
  done: items.filter(_ => _.urgency === 'done').length,
});

const customPromptFields = () => ({
  inventoryAdviceCustomPrompt: {
    label: '前提条件',
    type: 'text',
    rows: 10,
    disablesTextTemplates: true,
    hint: 'AIへの指示に毎回含まれます。定期実行にも反映されます',
  },
});

module.exports = {
  customPromptFields,
  urgencyLevels,
  parseAdvice,
  countByUrgency,
};
